export const enMenuItemsTranslations = {
  menuItems: {
    // Page titles
    title: "Menu Items",
    subtitle: "Manage and organize your restaurant menu items",
    addItem: "Add Menu Item",
    editItem: "Edit Menu Item",

    // Menu item properties
    name: "Item Name",
    namePlaceholder: "Enter item name",
    description: "Description",
    descriptionPlaceholder: "Describe the menu item...",
    price: "Price",
    discountedPrice: "Discounted Price",
    image: "Item Image",
    category: "Category",
    selectCategory: "Select a category",
    status: "Status",

    // Item status and options
    published: "Published",
    draft: "Draft",
    available: "Available",
    unavailable: "Unavailable",
    featured: "Featured",

    // Dietary preferences
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    glutenFree: "Gluten-Free",
    itemSettings: "Item Settings",
    dietaryPreferences: "Dietary Preferences",

    // Actions
    publish: "Publish",
    unpublish: "Unpublish",
    feature: "Feature",
    unfeature: "Unfeature",
    markAvailable: "Mark as Available",
    markUnavailable: "Mark as Unavailable",
    deleteTitle: "Delete Menu Item",
    // deleteConfirmation: 'Are you sure you want to delete this item? This action cannot be undone.',

    // View options
    gridView: "Grid View",
    listView: "List View",

    // Empty states
    noItems: "No Menu Items",
    noItemsYet: "No menu items yet",
    createFirstItemDescription:
      "Start adding menu items to display on your restaurant menu",
    noMatchingItems: "No matching items found",
    tryAdjustingFilters: "Try adjusting your search or filters",
    noImage: "No Image",
    noCategories: "No categories available",
    noCategoriesWarning: "You need to create categories first",

    // Export
    exportStarted: "Export started. You will be notified when it completes.",

    uploadImage: "Click to upload image",
    updateItem: "Update Item",
    noDescription: "No description",
    deleting: "Deleting...",
    deleteMessage:
      "Are you sure you want to delete this item? This action cannot be undone.",
    deleteFailed: "Failed to delete menu item. Please try again.",

    noItemsInCategory: "This category doesn't have any items yet",
    addFirstItem: "Add First Item",
    filteredByCategory: "Filtered by category",

    basicInformation: "Basic Information",
    additionalDetails: "Additional Details",
    imageAndSettings: "Image & Settings",
    options: "Options",
    addIngredientPlaceholder: "Type ingredient name and press Enter",
    preparationTime: "Preparation Time (minutes)",

    // Errors
    errors: {
      nameRequired: "Item name is required",
      invalidPrice: "Please enter a valid price",
      invalidDiscountedPrice:
        "Discounted price must be less than regular price",
      categoryRequired: "Category is required",
      createFailed: "Failed to create menu item. Please try again.",
      updateFailed: "Failed to update menu item. Please try again.",

      discountedPriceTooHigh:
        "Discounted price must be lower than regular price",
      deleteFailed: "Failed to delete menu item. Please try again.",

      invalidCalories: "Please enter a valid number of calories",
      invalidPreparationTime: "Please enter a valid preparation time",
      variantOptionNameRequired: "Variant option {{index}} name is required",
      variantChildNameRequired: "Variant option {{optionIndex}} child {{childIndex}} name is required",
      variantChildPriceRequired: "Variant option {{optionIndex}} child {{childIndex}} price must be a valid positive number",
      dietaryPreferencesFetchFailed: "Failed to load dietary preferences",
    },

    itemNotFound: "Menu Item Not Found",
    itemNotFoundDescription:
      "The menu item you are looking for does not exist or has been removed.",
    backToMenuItems: "Back to Menu Items",
    noImageAvailable: "No Image Available",
    minutes: "minutes",
    pricing: "Pricing",
    regularPrice: "Regular Price",
    quickActions: "Quick Actions",
    itemDetails: "Item Details",
    ingredients: "Ingredients",
    dietaryInfo: "Dietary Information",
    noDietaryRestrictions: "No special dietary restrictions",
    noDietaryPreferences: "No dietary preferences assigned",
    dietaryPreferencesInfo: "This item has been tagged with the dietary preferences shown above.",
    calories: "Calories",
    cal: "cal",
    spiceLevel: "Spice Level",
    spice: {
      none: "No Spice",
      mild: "Mild",
      medium: "Medium",
      hot: "Hot",
      extra_hot: "Extra Hot",
    },
    activityStats: "Activity & Stats",
    createdAt: "Created At",
    lastUpdated: "Last Updated",
    analyticsComingSoon: "Analytics and performance data coming soon",
    noCategory: "No Category",
    unknownCategory: "Unknown Category",

    pricingDetails: "Pricing Details",
    dietaryInformation: "Dietary Information",
    saveAmount: "Save ${{amount}} ({{percentage}}% off)",
    yes: "Yes",
    no: "No",
    itemStatistics: "Item Statistics",
    itemPerformance: "Item Performance",
    performanceDescription:
      "Analytics and insights for this menu item will be available soon",

    overview: "Overview",
    analytics: "Analytics",
    actions: "Actions",
    itemAnalytics: "Item Analytics",
    avgClicks: "Avg. Clicks",
    avgTimeSpent: "Avg. Time Spent",
    avgTime: "Avg. Time",
    perMonth: "per month",
    clicksOverTime: "Clicks Over Time",
    timeSpentOverTime: "Time Spent Over Time",
    combinedAnalytics: "Combined Analytics",
    clicks: "Clicks",
    timeSpent: "Time Spent",
    timeSpentMinutes: "Time Spent (min)",
    noAnalyticsData: "No Analytics Data",
    noAnalyticsDescription:
      "Analytics data will appear here once customers start viewing this item.",
    item: "Item",

    // Labels/Tags
    foodLabels: "Food Labels",
    foodLabelsDescription:
      "Select labels that describe this menu item to help customers find what they're looking for",
    selectedLabels: "Selected Labels",
    clearAllLabels: "Clear All",
    selectHealthyLabels: "Select Healthy",

    // New tabs
    labels: "Labels",

    // Settings helpers
    publishedHelper: "Item is visible to customers",
    draftHelper: "Item is saved as draft and not visible to customers",
    availableHelper: "Item is available for ordering",
    unavailableHelper: "Item is temporarily unavailable",
    featuredHelper: "Item will be highlighted as featured",
    notFeaturedHelper: "Item will appear normally in the menu",

    // Preview
    itemPreview: "Item Preview",
    itemName: "Item Name",
    itemDescription: "Item Description",

    nutritionAndPreparation: "Nutrition & Preparation",
    nutritionalInfo: "Nutritional Information",
    nutritionalInfoDescription:
      "Adding nutritional details helps customers make informed choices about their meals.",
    englishIngredients: "English Ingredients",
    arabicIngredients: "Arabic Ingredients",
    addArIngredientPlaceholder: "Type Arabic ingredient name and press Enter",
    enIngredientNote:
      "Note: You can enter a single ingredient or a list separated by ';'",
    arIngredientNote:
      "Note: You can enter a single ingredient or a list separated by '؛' (shift + P)",

    // Empty states
    noIngredientsYet: "No ingredients added yet",
    ingredientsWillAppearHere: "Ingredients and ingredient groups will appear here when added to this menu item.",

    // Actions
    clearAllIngredients: "Clear All Ingredients",
    addCommonIngredients: "Add Common Ingredients",
    autoLabeling: "Auto Labeling",

    // Ingredient Management
    ingredientManagement: "Ingredient Management",
    individualIngredients: "Individual Ingredients",
    ingredientGroups: "Ingredient Groups",
    ingredient: "ingredient",
    group: "group",
    groups: "groups",
    noIngredientsInGroup: "No ingredients in this group",
    ingredientsAndGroups: "Ingredients & Groups",
    addIngredientsOrGroups: "Add individual ingredients or ingredient groups to this item",
    addIngredientsOrGroupsButton: "Add Ingredients or Groups",
    searchIngredients: "Search ingredients...",
    searchGroups: "Search groups...",
    noAvailableIngredients: "No available ingredients to add",
    noAvailableGroups: "No available groups to add",
    noIngredientsFound: "No ingredients found matching",
    noGroupsFound: "No groups found matching",

    // Basic Information Tab
    englishInformation: "English Information",
    arabicInformation: "Arabic Information",
    arabicName: "Arabic Name",
    arabicDescription: "Arabic Description",
    arabicNamePlaceholder: "Enter Arabic item name",
    arabicDescriptionPlaceholder: "Describe the menu item in Arabic...",

    // Cross-Selling
    crossSelling: "Cross-Selling",
    crossSellingDescription: "Force up to 3 items to recommend when customers add this item",
    suggestedItems: "Suggested Items",
    noSuggestedItems: "No suggested items selected",
    addSuggestedItems: "Add Suggested Items",
    searchItems: "Search items...",
    searchToAdd: "Search to add items...",
    selectedCount: "{{count}}/3 selected",
    maxReached: "Maximum 3 items allowed",
    noSelectedItems: "No items selected. Search above to add.",
    crossSellingSaved: "Recommendations saved",
    crossSellingSaveFailed: "Failed to save recommendations",
    removeFromManual: "Remove from manual recommendations",
  },
};
